import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logOut, setCredentials } from '../store/reducers/authSlice';
import { clearUser } from '../store/reducers/userSlice';
import {setIsError} from "../store/reducers/notificationSlice";

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_API_URL,
    credentials: 'same-origin',
    prepareHeaders: (headers, { getState }) => {
        const token = getState().auth.token;
        if (token) {
            headers.set('authorization', `Bearer ${token}`);
        }
        return headers;
    }
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);
    const refresh_token = JSON.parse(localStorage.getItem('jwt_refresh'))

    if(result.error && (result.error?.data?.error_code!==10100 && result?.error?.status !== 403)) {
        api.dispatch(setIsError(result?.error?.data.message))
    } else if (result?.error?.status === 403) {
        console.log('sending refresh token');
        const username = JSON.parse(localStorage.getItem('user')).username
        const refreshResult = await baseQuery({url: './public/auth', method:'POST', body: {username, grant_type:'refresh_token', refresh_token}}, api, extraOptions);

        if (refreshResult.data) {
            api.dispatch(setCredentials({
                ...refreshResult.data
            }));
            result = await baseQuery(args, api, extraOptions);
        } else {
            api.dispatch(logOut());
            api.dispatch(clearUser());
            localStorage.clear();
        }
    }
    return result;
};

export const api = createApi({
    reducerPath: 'api',
    baseQuery: baseQueryWithReauth,
    endpoints: () => ({})
});
